import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { SingleQuestionComponent } from './singleQuestion.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [SingleQuestionComponent],
  exports: [SingleQuestionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SingleQuestionModule {}
